









































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";

@Component
export default class DocumentForm extends Vue {
  @Prop({ type: Number, required: true })
  documentId!: number;

  name: 'DocumentForm';
  formData: any = {};
  isSubmitting: boolean = false;
  submitResult: boolean = false;
  isSubmitted: boolean = false;
  spatialOptions: [] = [];
  documentTypes: [] = [];
  frequency: [] = [];
  correctionTypes: [] = [];
  categories: [] = [];
  subCategories: any[] = [];
  isNew = false;
  source: any = {};
  isCancelled: boolean = false;

  async mounted() {
    await this.getDocumentData(this.documentId);

    this.spatialOptions = (
      await axios.get<[]>("/lookup/spatial-coverage", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.documentTypes = (
      await axios.get<[]>("/lookup/document-type", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.frequency = (
      await axios.get<[]>("/lookup/frequency", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.correctionTypes = (
      await axios.get<[]>("/lookup/correction-type", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.categories = (
      await axios.get<[]>("/lookup/categories", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;

    this.loadSubcategories(this.formData.area_Id);
  }

  async submit() {
    this.isSubmitting = true;
    this.submitResult = false;
    this.formData.isCancelled = this.isCancelled;
    this.formData.update_status = parseInt(this.formData.update_status);

    var plannedDateToSave = moment(this.formData.planned_publishing_date).startOf("day").toDate();
    plannedDateToSave.setHours(plannedDateToSave.getHours() + 12);
    this.formData.planned_publishing_date = plannedDateToSave;

    if (this.formData.actual_publishing_date) {
      var actualDateToSave = moment(this.formData.actual_publishing_date).startOf("day").toDate();
      actualDateToSave.setHours(actualDateToSave.getHours() + 12);
      this.formData.actual_publishing_date = actualDateToSave;
    }

    try {
      await axios.post(
        `/document/${this.documentId}`,
        this.formData,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        }
      );
      this.isSubmitted = true;
      this.submitResult = true;
      this.isSubmitting = false;
    } catch {
      this.isSubmitted = true;
      this.submitResult = false;
      this.isSubmitting = false;
    }
  }

  GoBack() {
    this.$router.go(-1);
  }

  formatter(d) {
    return d.toLocaleDateString();
  }

  async loadSubcategories(value) {
    let areaId = value;
    this.subCategories = (
      await axios.get<[]>("/lookup/subcategories?area=" + areaId, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    for (var subCat of this.subCategories) {
      let subareaName: string = subCat['shortened_area_name'];
      subCat['shortId'] = parseInt(subareaName.split('-')[1]);
    }
  }

  async getDocumentData(documentId: any) {
    var doc = await axios.get(`/document/${documentId}`, {
      headers: {
        Authorization: "Bearer " + localStorage.token,
      },
    });

    var plannedDate = new Date(doc.data.planned_publishing_date);
    var actualPublishingDate = doc.data.actual_publishing_date
      ? new Date(doc.data.actual_publishing_date)
      : null;
    this.formData = doc.data;
    this.formData.planned_publishing_date = plannedDate;
    this.formData.actual_publishing_date = actualPublishingDate;
    this.isCancelled = doc.data.publishing_status_id === 7;
    var node = await axios.get(`/cat/v2/${this.formData.node_id}`, {
      headers: {
        Authorization: "Bearer " + localStorage.token,
      },
    });
  }

  closeModal() {
    this.$emit('close');
  }
}
